export default __webpack_public_path__ + "static/media/91.9c4b3397.jpg";